import { Button } from 'flowbite-react'

const ErrorFallback = ({
	error,
	resetErrorBoundary
}: {
	error: string
	resetErrorBoundary: () => void
}) => (
	<div className='flex h-screen flex-col items-center justify-center bg-gray-100'>
		<div className='text-2xl text-red-500'>Something went wrong</div>
		{globalThis.location.hostname === 'localhost' ? (
			<div className='mb-4 text-lg text-gray-700'>{error}</div>
		) : null}
		<Button
			outline
			color='primary'
			onClick={resetErrorBoundary}
			className='bg-blue-500 transition-colors duration-300 hover:bg-blue-600'
		>
			Try Again
		</Button>
	</div>
)

export default ErrorFallback
